import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserStudent/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserStudent/Get',
      params,
    });
  },
  GetByStdid(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserStudent/GetByStdid',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/delete',
      data,
    });
  },
  // 批次停用
  BatchDisable(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/BatchDisable',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
  // 批次更新
  BatchChangePwd(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/BatchChangePwd',
      data,
    });
  },
  GetByAcc(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserStudent/GetByAcc',
      params,
    });
  },
  ChangePermission(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserStudent/ChangePermission',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
